import { DefaultError } from '@tanstack/react-query';
import { Stack, Typography, IconButton } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import React from 'react';

type ErrorHandlerProps = {
    error: DefaultError | null | undefined;
    onRetry?: () => void;
};

export default function ErrorHandler({ error, onRetry }: ErrorHandlerProps) {
  if (!error) return null;

  //@ts-ignore
  const message = error?.response?.data?.message;

  return (
    <Stack flexDirection="row" justifyContent="center">
      <Stack>
        <Typography
          style={{
            fontSize: 14,
            color: "red",
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          Error: {error.message}
        </Typography>
        {message && (
          <Typography
            style={{
              fontSize: 14,
              color: "red",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            Message: {message}
          </Typography>
        )}
      </Stack>
      {onRetry && (
        <Stack>
          <IconButton onClick={onRetry}>
            <RefreshIcon />
          </IconButton>
        </Stack>
      )}
    </Stack>
  );
}
